import type {
  EventinstanceDefaultFragment,
  NodeArticleFragment,
  NodeContactFragment,
  NodePageFragment,
} from '#graphql-operations'

const ROUTE_ENTITY = Symbol('route_entity')

type RouteEntities =
  | NodePageFragment
  | NodeArticleFragment
  | NodeContactFragment
  | EventinstanceDefaultFragment

// Signature to use the current route entity.
export function useRouteEntity(): ComputedRef<RouteEntities | null>

// Signature to provide a route entity.
export function useRouteEntity(
  providedEntity: ComputedRef<RouteEntities>,
): undefined

/**
 * Composable to either provide or inject the current route entity.
 */
export function useRouteEntity(
  providedEntity?: ComputedRef<RouteEntities>,
): ComputedRef<RouteEntities | null> | undefined {
  if (providedEntity) {
    provide(ROUTE_ENTITY, providedEntity)
    return
  }
  const entity = inject<ComputedRef<RouteEntities | null> | null>(
    ROUTE_ENTITY,
    null,
  )

  if (entity) {
    return entity
  }

  return computed(() => null)
}
